import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MemberService } from '../../services/jrni/member.service';
import { DepartmentService } from '../../services/jrni/department.service';
import { Router } from '@angular/router';
import { AlertService } from '../../_alert';
import { ServicesService } from '../../services/jrni/services.service';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatastoreService } from '../../services/datastore.service';
import { AvailabilityService } from '../../services/jrni/availability.service';
import { AppConfig } from '../../app.config';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { AmazonService } from '../../services/jrni/amazon.service';
import { ApiService } from '../../services/jrni/api.service';
import { environment } from '../../../environments/environment';
import moment from 'moment';
@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss'],
})
export class ServicesComponent implements OnInit {
  selectedDepartment;
  pageTitle;
  faChevronRight = faChevronRight;
  faChevronLeft = faChevronLeft;
  servicePageText;
  servicesList: any = [];
  selectedService;
  private customerQuestions = AppConfig.settings.customerQuestions;
  private services = AppConfig.settings.services;
  location;
  permitQuestion = false;

  constructor(
    private departmentService: DepartmentService,
    private router: Router,
    protected alertService: AlertService,
    private servicesService: ServicesService,
    private cdref: ChangeDetectorRef,
    private translateService: TranslateService,
    private spinner: NgxSpinnerService,
    private datastoreService: DatastoreService,
    private amazonService: AmazonService,
    private availabilityService: AvailabilityService,
    private apiService: ApiService
  ) { }

  ngOnInit() {
    this.scrollToTop();
    this.spinner.show();
    this.datastoreService.bookingForm = null;
    this.datastoreService.selectedDate = null;
    this.datastoreService.selectedSlot = null;
    this.availabilityService.setSelectedSlot(null);
    this.getParentDepartment();
  }

  // The service is picked before the location, so the services are read from
  // the parent department rather than from a location
  async getParentDepartment() {
    try {
      // reset the restricted booking
      this.datastoreService.isRestrictedBooking = false;
      this.datastoreService.isRestrictedAsbestosBooking = false;
      this.datastoreService.isCommercialBooking = false;

      const parentDepartment =
        await this.departmentService.getParentDepartment();

      const pId = parentDepartment.id;
      const pClient = parentDepartment.self.split('://')[1].split('.')[0];
      const token: any = await this.apiService.getToken(pClient, pId);
      if (token) {
        environment.clientToken = token.token;
      }
      this.datastoreService.config = await this.apiService.getConfig(
        pClient,
        pId
      );

      this.datastoreService.parentDepartment = parentDepartment;
      this.datastoreService.extra = parentDepartment.extra;

      this.selectedDepartment = parentDepartment;
      this.departmentService.set(parentDepartment);

      // Get the configurable data
      if (parentDepartment?.extra?.services_page_title) {
        this.pageTitle = parentDepartment.extra.services_page_title;
      } else {
        this.pageTitle = 'Services title not set';
      }
      if (parentDepartment?.extra?.services_page_text) {
        this.servicePageText = parentDepartment.extra.services_page_text;
      }

      await this.getServices();
    } catch (err) {
      this.alertService.error(
        this.translateService.instant('COMMON.GENERAL_ERR')
      );
      this.spinner.hide();
    }
  }

  // Get the available services on the selected department
  async getServices() {
    let services = await this.servicesService.getServices(
      this.selectedDepartment
    );

    // if (services.length === 1) {
    //   this.selectService(services[0])
    // } else {
    console.log(services);

    for (let element of services) {
      //let childServices = await element.$getChildServices();

      // let service: any = {};

      // service.name = element.name
      // service.description = element.description

      // childServices.forEach(element => {
      //   element.$getImages().then((image) => {
      //     service.image = image[0];
      //   });
      // });
      if (
        element.extra === undefined ||
        element.extra.permits_enabled === undefined
      ) {
        element.extra = { permits_enabled: 'No' };
      }
      console.log(element);
      element.permitQuestion = undefined;
      element.vehicleRegQuestion = undefined;
      if (element.extra.admin_only_service !== 'Yes') {
        element.$getImages().then((image) => {
          element.image = image[0];
          this.cdref.detectChanges();
        });
        this.servicesList.push(element);
      }

    }
    this.spinner.hide();
    // }
  }

  selectService(service) {
    this.selectedService = service;

    this.continue('/departments');
  }

  async askQuestion(service) {
    const res = await service.$get('questions');
    let question = res.questions.find((x) => {
      return x.id.toString() === AppConfig.settings.permitQuestion.toString();
    });
    console.log(res);
    console.log(question);
    service.permitQuestion = question;
    console.log(service.permitQuestion);

    question = res.questions.find((x) => {
      return (
        x.id.toString() === AppConfig.settings.vehicleRegQuestion.toString()
      );
    });
    service.vehicleRegQuestion = question;
    service.permitQuestion.error = false;
    service.permitQuestion.apiError = false;
    service.permitQuestion.apiNote = false;
    service.permitQuestion.apiSuccess = false;
    service.permitQuestion.answer = '';

    service.permitQuestion.error = false;
    service.permitQuestion.apiError = false;
    service.permitQuestion.apiNote = false;
    service.permitQuestion.apiSuccess = false;
    service.showContinue = false;
    service.vehicleRegQuestion.answer = '';

    service.status = 0;
  }

  async checkPermit(service) {
    this.spinner.show();

    // this will do a check to see if the permit exists and will then load it
    service.permitQuestion.error = false;
    service.permitQuestion.apiError = false;
    service.permitQuestion.apiNote = false;
    service.permitQuestion.apiSuccess = false;
    service.showContinue = false;
    service.status = 0;
    if (service.permitQuestion.answer) {
      const companyName = AppConfig.settings.apiServer.api_url
        .split('//')[1]
        .split('.council')[0];
      const permit: any =
        await this.amazonService.checkPermitApplicationOperation(
          this.selectedDepartment.id,
          companyName,
          service.permitQuestion.answer,
          'validatePermit'
        );
      service.permit = permit;
      if (permit.found === true) {
        // this.continue("/calendar");
        if (permit.error === 'invalid') {
          service.permitQuestion.apiError =
            'Permit number invalid. Please try again.';
        } else if (permit.error === 'no allowance') {
          service.permitQuestion.apiError =
            'Your permit allowance has been used. Please apply for a new permit.';
        } else if (permit.error === 'expired') {
          service.permitQuestion.apiError =
            'Your permit has expired. Please renew your permit';
        } else if (permit.reg) {
          if (permit.hire) {
            service.permitQuestion.apiNote = `Your permit is for a hired vehicle, you must provide the following when you visit:
            <div>
              <ul>
                <li>the short-term hire agreement</li>
                <li>photographic identification</li>
                <li>proof of address</li>
              </ul>
            </div>
            Please enter the vehicle registration for your permit.
            `;
          } else {
            service.permitQuestion.apiNote =
              'Please enter the vehicle registration for your permit.';
          }
          service.status = 1;
        } else {
          service.permitQuestion.apiNote = `Your permit is for a hired vehicle, you must provide the following when you visit:
          <div>
            <ul>
              <li>the short-term hire agreement</li>
              <li>photographic identification</li>
              <li>proof of address</li>
            </ul>
          </div>
          `;
          service.permitQuestion.apiSuccess = `Your permit is valid and you have ${permit.remaining} visits remaining. Please continue.`;
          console.log(service.permitQuestion.apiSuccess);
          service.showContinue = true;
        }
        if (permit.vehicle_model) {
          service.vehicleRegQuestion.vehicle_model = permit.vehicle_model;
        }
        if (permit.hire) {
          service.permitQuestion.hire = 'Yes';
        } else {
          service.permitQuestion.hire = 'No';
        }
      } else {
        // this.alertService.warn("Permit invalid");
        service.permitQuestion.apiError =
          'Permit number not found. Please try again.';
      }
    } else {
      // this.alertService.warn("Please enter your permit number");
      service.permitQuestion.error = true;
    }
    this.spinner.hide();
  }
  cancelPermit(service) {
    service.permitQuestion.error = false;
    service.permitQuestion.apiError = false;
    service.permitQuestion.apiNote = false;
    service.permitQuestion.apiSuccess = false;
    service.showContinue = false;
    service.permitQuestion.answer = '';
    service.status = 0;
  }

  async checkVehicleReg(service) {
    this.spinner.show();
    // this will do a check to see if the permit exists and will then load it
    service.vehicleRegQuestion.error = false;
    service.vehicleRegQuestion.apiError = false;
    service.vehicleRegQuestion.apiNote = false;
    service.vehicleRegQuestion.apiSuccess = false;
    service.showContinue = false;
    if (service.vehicleRegQuestion.answer) {
      const companyName = AppConfig.settings.apiServer.api_url
        .split('//')[1]
        .split('.council')[0];
      const reg: any = await this.amazonService.checkPermitApplicationOperation(
        this.selectedDepartment.id,
        companyName,
        service.permitQuestion.answer,
        'validateVehicleOnly',
        service.vehicleRegQuestion.answer
      );

      if (reg.found) {
        this.selectedService = service;
        console.log(this.selectedService);
        // this.continue("/calendar");
        const permitData = JSON.parse(reg.record.data);
        const expiry = moment(reg.record.valid_to).format("DD-MM-YYYY");
        service.vehicleRegQuestion.apiSuccess = `Your permit is valid and you have ${service.permit.remaining} visits remaining. Your permit expires on ${expiry}. Please continue.`;
        permitData.permit_id = reg.record.permit_id;
        this.datastoreService.permitData = permitData;
        service.showContinue = true;
      } else {
        service.vehicleRegQuestion.apiError =
          'Vehicle registration does not match permit. Please try again.';
      }
    } else {
      // this.alertService.warn("Please enter your permit number");
      service.vehicleRegQuestion.error = true;
    }
    this.spinner.hide();
  }

  cancelReg(service) {
    service.vehicleRegQuestion.error = false;
    service.vehicleRegQuestion.apiError = false;
    service.vehicleRegQuestion.apiNote = false;
    service.vehicleRegQuestion.apiSuccess = false;
    service.showContinue = false;
  }

  applyForPermit(service) {
    this.selectedService = service;

    this.continue('/permits');
  }

  amendPermit(service) {
    this.selectedService = service;

    this.continue('/amend-permits');
  }

  continue(goTO) {
    if (this.selectedService) {
      console.log(this.selectedService);
      this.servicesService.setParentService(this.selectedService);
      this.servicesService.set(this.selectedService);
      this.router.navigate([goTO]);
    } else {
      this.alertService.warn('Please select a service before proceeding');

      this.scrollToTop();
    }
  }

  // scroll to the top of the page
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }
}
